import { createI18n } from "vue-i18n";

import zh_TW from "../../lang/Frontend/zh_tw.json";
import en from "../../lang/Frontend/en.json";
//定義標識符
const i18n = new createI18n({
	locale: "zh-TW", // 語言標識
	fallbackLocale: "zh-TW",
	//this.$i18n.locale // 通過切換locale的值來實現語言切換
	messages: {
		"zh-TW": zh_TW, // 中文語言包
		"en-US": en, // 英文語言包
	},
});
export { i18n };
